import type { RouteObject } from 'react-router-dom';
import EvaluationsPage from '@pages/EvaluationsPage/EvaluationsPage';

const evaluationsRoutes: RouteObject[] = [
    { path: '/admin/evaluations', element: <EvaluationsPage /> },
];

export default evaluationsRoutes;
